module.exports = __webpack_public_path__ + "img/mostly-sunny.e4c7521e.png";